import React, { useEffect, useRef } from 'react';
import {
  LinterName,
  DescriptionByName,
  TemplateParamsByName,
} from '@scale/shared/lidarlite/linting';
import SanitizedMarkdown from 'design-system/SanitizedMarkdown';
import { LidarLiteLinterSection } from '@scale/shared/types/corp/linterConfigDocs';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import { styles, LintExamples } from './LinterConfigDocsComponents';

export const LidarLiteConfig = ({
  linter,
  selected = true,
  getStyle,
}: {
  linter: LidarLiteLinterSection;
  selected: boolean;
  getStyle: (selected: boolean) => Record<string, string>;
}) => {
  const classes = styles();
  const linterRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (selected) {
      linterRef?.current?.scrollIntoView();
    }
  }, [selected]);

  return (
    <div
      id={`${linter.name}`}
      style={{ maxWidth: 1000, width: '90%', ...getStyle(selected) }}
      ref={linterRef}
    >
      <Section
        name={
          <div style={{ display: 'inline-block' }}>
            <span>{linter.name}</span>
            <div style={{ display: 'inline', marginLeft: '6px' }}></div>
          </div>
        }
        forceHidden={!selected}
        linterSelected={selected}
        sectionId={linter.name}
      >
        <div>
          <div className={classes.linterSectionBody}>
            <SanitizedMarkdown
              text={`**Description:** ${DescriptionByName[linter.name as LinterName]}`}
            />
            <h3>Example Linters</h3>
            {TemplateParamsByName[linter.name as LinterName].length && (
              <LintExamples examples={TemplateParamsByName[linter.name as LinterName]} />
            )}
          </div>
        </div>
      </Section>
    </div>
  );
};
